import { HttpResponse } from '@angular/common/http';

export function getUrlParam(paramName: string, urlString: string): string | null {
  try {
    const url = new URL(urlString);
    const params = url.searchParams;

    return params.get(paramName);
  } catch (error) {
    console.error('Invalid URL:', error);
    return null;
  }
}

export function toNumber(v?: string): number {
  if (v) {
    return Number(`${v}`.replace(',', '.').replaceAll(' ', '') || 0);
  } else {
    return 0;
  }
}

export function dateToPLString(value: any, withTime = false): string | undefined {
  const date = new Date(value);
  const day = date.getDate();
  const month = date.getMonth() + 1;
  const year = date.getFullYear();
  const hours = date.getHours();
  const minutes = date.getMinutes();
  if (withTime) {
    return value
      ? `${('00' + day).slice(-2)}.${('00' + month).slice(-2)}.${year} ${('00' + hours).slice(-2)}:${('00' + minutes).slice(-2)}`
      : undefined;
  } else {
    return value
      ? ('00' + day).slice(-2) + '.' + ('00' + month).slice(-2) + '.' + year
      : undefined;
  }
}

export function getFileNameFromHttpResponse(resp: HttpResponse<any>): string | null {
  const contentDispositionHeader = resp.headers.get('content-disposition');
  if (contentDispositionHeader) {
    const result = contentDispositionHeader.split(';')[1].trim().split('=')[1];
    return result.replace(/"/g, '');
  } else {
    return null;
  }
}

export function clearDate(date: string | number | Date | null): Date | null {
  if (!date) {
    return null;
  }
  const d = new Date(date);
  d.setHours(0, 0, 0, 0);
  return d;
}

export function onlyUnique(value: any, index: number, array: any[]) {
  return array.indexOf(value) === index;
}

export function calcDaysBetweenDates(startDate: Date, endDate: Date): number | null {
  if (!endDate?.getTime() || !startDate?.getTime()) {
    return null;
  }
  const diffInMilliseconds = Math.abs(endDate.getTime() - startDate.getTime());
  return Math.ceil(diffInMilliseconds / (1000 * 60 * 60 * 24)) + 1;
}
